"use client";

import React from "react";
import Image from "next/image";
import styles from "./ServicesBlock.module.css";

interface ServiceItem {
  icon: string;
  title: string;
  desc: string;
}

interface ServicesBlockProps {
  items: ServiceItem[];
  heading?: string;
  subheading?: string;
}

const ServicesBlock: React.FC<ServicesBlockProps> = ({
  items,
  heading,
  subheading,
}) => {
  return (
    <section className={styles.section}>
      <div className="container-lg">

        {heading && (
          <div className={styles.headingBlock}>
            <h3 className={styles.heading}>{heading}</h3>
            {subheading && <p className={styles.subheading}>{subheading}</p>}
          </div>
        )}

        <div className="row">
          {items.map((item, index) => (
            <div className={`col-lg-6 col-12 ${styles.fadeUp}`} key={index}>
              <div className={styles.card}>
                <Image
                  src={item.icon}
                  alt={item.title}
                  width={80}
                  height={80}
                  className={styles.icon}
                />
                <h5 className={styles.cardTitle}>{item.title}</h5>
                <p className={styles.cardDesc}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ServicesBlock;
